export default __webpack_public_path__ + "static/5-242421a20a5f488d7d03f1eec61ef0f8.jpeg";